import {
  NewArrivalsPage,
  getStaticProps,
} from '@public/CmsPage/ShowroomPage/NewArrivalsPage'

export { getStaticProps }

export default NewArrivalsPage
